module.exports = __webpack_public_path__ + "img/instagram-icon.6a13fdb3.svg";